import { useRef, useEffect, EffectCallback, DependencyList } from "react";

const useComponentDidUpdate = (
	effect: EffectCallback,
	deps?: DependencyList
): void => {
	const hasMounted = useRef(false);

	useEffect(() => {
		if (!hasMounted.current) {
			hasMounted.current = true;
			return;
		}
		effect();
	}, deps);
};

export default useComponentDidUpdate;
